import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { solutionCategories } from '../../data/solutionCategories';

const order = ['water-treatment', 'bottling-machinery', 'packaging-machinery', 'beverage-plants', 'bottle-manufacturing'];

const blurbs = {
  'water-treatment': 'RO, WTP, STP, ETP, MBR, ZLD, MEE & ATFD systems',
  'bottling-machinery': 'RFC filling machines 30–200 BPM, unscramblers, conveyors',
  'packaging-machinery': 'Shrink, labelling, batch coding & cartoning',
  'beverage-plants': 'Mineral water, juice & CSD turnkey projects',
  'bottle-manufacturing': 'PET blowing, compressors, dryers & chillers'
};

export const SolutionCategoriesSection = () => (
  <section className="py-16 md:py-20 bg-white" data-testid="solution-categories-section">
    <div className="container mx-auto px-4">
      <div className="text-center mb-12">
        <div className="text-sm font-bold text-alden-green uppercase tracking-widest mb-2">Products &amp; Solutions</div>
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
          One Engineering Partner. Five Solution Verticals.
        </h2>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-5">
        {order.map((slug) => {
          const cat = solutionCategories[slug];
          return (
            <Link key={slug} to={`/solutions/${slug}`} data-testid={`home-category-${slug}`}
              className="group rounded-2xl overflow-hidden border-2 border-gray-200 hover:border-alden-green hover:shadow-xl transition-all bg-white">
              <div className="h-36 overflow-hidden">
                <img src={cat.heroImage} alt={`${cat.name} - Alden Technologies`} loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-5">
                <h3 className="font-bold text-gray-900 group-hover:text-alden-green transition-colors">{cat.name}</h3>
                <p className="text-xs text-gray-600 mt-2 leading-relaxed">{blurbs[slug]}</p>
                <span className="inline-flex items-center gap-1 text-sm font-semibold text-alden-green mt-3">
                  Explore <ArrowRight className="w-4 h-4" />
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  </section>
);

export default SolutionCategoriesSection;
